import { useContext } from "react";
import { AuthContext } from "../context/authContext";

function useAuth() {
  const { token, updateToken } = useContext(AuthContext);

  return {
    token,
    updateToken,
  };
}

export default useAuth;
